import React from "react";
import { cn } from "../../DashboardPage/lib/utils";
import { badgeBaseClass, badgeTones } from "./StatusBadge";

/**
 * The single definition of an email delivery-status badge.
 *
 * Email logs have their own status vocabulary (SENT / FAILED / PENDING /
 * QUEUED), unrelated to pitch statuses, but they share StatusBadge's shell and
 * tone tokens so "sent" green here is literally the same green as "delivered"
 * green on /dashboard. Previously the page and the details modal each carried
 * their own copy of this map and had already drifted (QUEUED was primary on one
 * and blue on the other).
 */

const TONES: Record<string, string> = {
  SENT: badgeTones.success,
  FAILED: badgeTones.danger,
  PENDING: badgeTones.warning,
  QUEUED: badgeTones.pending,
};

export function getEmailStatusTone(status: string): string {
  return TONES[status] ?? badgeTones.neutral;
}

interface EmailStatusBadgeProps {
  status: string;
  className?: string;
}

export default function EmailStatusBadge({
  status,
  className,
}: EmailStatusBadgeProps) {
  return (
    <span className={cn(badgeBaseClass, getEmailStatusTone(status), className)}>
      {status}
    </span>
  );
}
